import { T } from "@supersig/validate";
import { idValidator } from "../misc/id-validator";
/**
 * A validator for asset record type Ids.
 *
 * @public */ export const assetIdValidator = idValidator("asset");
/**
 * Create a validator for an asset record type.
 *
 * @param type - The type of the asset
 * @param props - The validator for the asset's props
 *
 * @public */ export function createAssetValidator(type, props) {
    return T.object({
        id: assetIdValidator,
        typeName: T.literal("asset"),
        type: T.literal(type),
        props,
        meta: T.jsonValue
    });
}
